<div  [class.required]="required">
  <!-- Single-line input -->
  <mat-form-field *ngIf="type !== 'textarea'; else textareaField"
                  appearance="outline"
                  [class.mat-form-field-disabled]="disabled"
                  class="width100"
                  [ngClass]="[cssClass]">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [type]="type"
      [value]="value"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="placeholder"
      (input)="handleChange($event)"
      (blur)="handleBlur()"
      [pattern]="type === 'email' ? emailPattern.source : null"
      [min]="type==='number' && min !== undefined ? min : null"
      [max]="type==='number' && max !== undefined ? max : null"
    />
  </mat-form-field>

  <!-- Multiline textarea -->
  <ng-template #textareaField>
    <mat-form-field appearance="outline"
                    [class.mat-form-field-disabled]="disabled"
                    class="width100 is-textarea"
                    [ngClass]="[cssClass]">
      <mat-label>{{ label }}</mat-label>
      <textarea
        matInput
        [rows]="rows"
        [disabled]="disabled"
        [required]="required"
        [placeholder]="placeholder"
        (input)="handleChange($event)"
        (blur)="handleBlur()"
      >{{ value }}</textarea>
    </mat-form-field>
  </ng-template>

  <div *ngIf="type==='email' && !emailValid" class="error-msg">
    Invalid email address
  </div>

  <div *ngIf="type==='number' && !numberValid" class="error-msg">
    Invalid number
    <ng-container *ngIf="integerOnly"> (integers only)</ng-container>
    <ng-container *ngIf="min !== undefined || max !== undefined">
      <span *ngIf="min !== undefined"> min: {{min}}</span>
      <span *ngIf="max !== undefined"> max: {{max}}</span>
    </ng-container>
  </div>

  <div *ngIf="type==='decimal' && !decimalValid" class="error-msg">
    Invalid decimal
    <ng-container *ngIf="decimalMin !== undefined || decimalMax !== undefined">
      <span *ngIf="decimalMin !== undefined"> min: {{decimalMin}}</span>
      <span *ngIf="decimalMax !== undefined"> max: {{decimalMax}}</span>
    </ng-container>
    <span> (max 2 decimal places)</span>
  </div>

  <div *ngIf="type==='password' && !passwordValid" class="error-msg">
    Password must be 8+ chars, include letters, numbers, and one special character
  </div>

  <div *ngIf="type==='tel' && !telValid" class="error-msg">Invalid phone number</div>
</div>